import React, { useEffect, useState } from "react";
import api from "../api";

export default function GalleryAdminPage() {
  const [images, setImages] = useState([]);
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");

  const fetchImages = async () => {
    const res = await api.get("/gallery");
    setImages(res.data);
  };

  useEffect(() => {
    fetchImages();
  }, []);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return alert("Оберіть зображення");
    const fd = new FormData();
    fd.append("image", file);
    if (title) fd.append("title", title);
    await api.post("/gallery", fd);
    setFile(null);
    setTitle("");
    fetchImages();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Видалити це зображення?")) {
      await api.delete(`/gallery/${id}`);
      fetchImages();
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Керування галереєю</h1>

      <form onSubmit={handleUpload} className="flex flex-col sm:flex-row gap-4 mb-8">
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setFile(e.target.files[0])}
          className="border p-2 rounded"
        />
        <input
          type="text"
          placeholder="Назва (необов’язково)"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="border p-2 rounded flex-1"
        />
        <button
          type="submit"
          className="bg-[#4A3B30] text-white px-4 py-2 rounded hover:bg-[#3A2420]"
        >
          Додати
        </button>
      </form>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {images.map((img) => (
          <div key={img.id} className="relative group">
            <img
              src={img.imageUrl}
              alt={img.title || ""}
              className="w-full h-40 object-cover rounded shadow"
            />
            <button
              type="button"
              onClick={() => handleDelete(img.id)}
              className="absolute top-1 right-1 bg-red-600 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
